// src/Redux/ActionTypes/productActionTypes.js

export const FETCH_PRODUCTS_REQUEST = "FETCH_PRODUCTS_REQUEST";
export const FETCH_PRODUCTS_SUCCESS = "FETCH_PRODUCTS_SUCCESS";
export const FETCH_PRODUCTS_FAILURE = "FETCH_PRODUCTS_FAILURE";
export const ADD_SUB_PRODUCT_ERROR = "ADD_SUB_PRODUCT_ERROR"
export const ADD_PRODUCT = "ADD_PRODUCT";
export const ADD_SUB_PRODUCT = "ADD_SUB_PRODUCT";

